import { render, staticRenderFns } from "./platform-notice-banner.vue?vue&type=template&id=4cae687f&scoped=true&"
import script from "./platform-notice-banner.vue?vue&type=script&lang=js&"
export * from "./platform-notice-banner.vue?vue&type=script&lang=js&"
import style0 from "./platform-notice-banner.vue?vue&type=style&index=0&id=4cae687f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cae687f",
  null
  
)

export default component.exports